import React from "react";

const RepaymentPage: React.FC = () => {
  return <div>RepaymentPage</div>;
};

export default RepaymentPage;
